module.exports = __webpack_public_path__ + "static/media/illust04-mobile.de78cdc5.png";